import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Chip, Switch } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAccordianClosed, setIsTaskDetailsDataUpdated, setTaskDetailsDataSaved } from '../../redux/commonSlice';
import { MuiStack } from './stackComponent';
import { EModuleSection, Module, isModuleConfig } from '../../constants';
import { systemColor } from '../../theme/systemColor';
import SkeletonLoader from './sketeton';
var Accordion = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordion, _extends({
    disableGutters: true,
    elevation: 0,
    square: true
}, props)); })(function (_ref) {
    var theme = _ref.theme;
    return {
        borderRadius: '12px'
    };
});
var AccordionSummary = styled(function (props) { /*#__PURE__*/ return React.createElement(MuiAccordionSummary, _extends({
    expandIcon: /*#__PURE__*/ React.createElement(ArrowForwardIosSharpIcon, {
        sx: {
            fontSize: '0.9rem'
        }
    })
}, props)); })(function (_ref2) {
    var theme = _ref2.theme;
    return {
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)'
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1)
        }
    };
});
var AccordionDetails = styled(MuiAccordionDetails)(function (_ref3) {
    var theme = _ref3.theme;
    return {
        padding: theme.spacing(2),
        borderTop: '1px solid rgba(0, 0, 0, .125)'
    };
});
var IOSSwitch = styled(function (props) { /*#__PURE__*/ return React.createElement(Switch, _extends({
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true
}, props)); })(function (_ref4) {
    var theme = _ref4.theme;
    return {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: 'white',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? systemColor.primary : systemColor.primary,
                    opacity: 1,
                    border: 0
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid white'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    };
});
export default function CustomeAccordianWithButton(props) {
    var _props$selected;
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = React.useState((_props$selected = props.selected) !== null && _props$selected !== void 0 ? _props$selected : false), switchEnabled = _b[0], setSwitchEnabled = _b[1];
    var dispatch = useDispatch();
    var _c = useSelector(function (state) { return state.crud; }), TotalPMPartPrice = _c.TotalPMPartPrice, PmPartCalculateLoader = _c.PmPartCalculateLoader;
    var handleClickFun = function (event) {
        setAnchorEl(event.currentTarget);
    };
    // useEffect(() => {
    //     if (!props.switchButtonsEnabled || !switchEnabled) {
    //         // props?.handleAccordianClick(false)
    //     }
    //     // if (switchEnabled) {
    //     //     props.handleClick();
    //     // }
    // }, [props.switchButtonsEnabled, switchEnabled])
    var onAccordianClick = function (event) {
        props === null || props === void 0 || props.handleAccordianClick(!(props !== null && props !== void 0 && props.isAccordianOpen));
        dispatch(setAccordianClosed(!(props !== null && props !== void 0 && props.isAccordianOpen)));
        if (props.handleClick && !(props !== null && props !== void 0 && props.isAccordianOpen)) {
            props.handleClick();
        }
    };
    var onSwitchChange = function () {
        if (props.switchButtonsEnabled) {
            return;
        }
        else {
            setSwitchEnabled(!switchEnabled);
            if (switchEnabled) {
                dispatch(setTaskDetailsDataSaved(true));
            }
            else {
                props.handleClick();
            }
        }
        dispatch(setIsTaskDetailsDataUpdated(true));
    };
    var getBorderColor = function (props, switchEnabled) {
        if (props.switchButtonsEnabled || switchEnabled) {
            if (props.highlightAccepted) {
                return "success.500"; // Green if `highlightAccepted` is true
            }
            else if (props.highlightRejected) {
                return "error.500"; // Red if `highlightRejected` is true
            }
            else {
                return "secondary.200"; // Blue if neither `highlightAccepted` nor `highlightRejected` is true
            }
        }
        return "#e0e0e0"; // Grey if both `switchButtonsEnabled` and `switchEnabled` are false
    };
    // console.log("TotalPMPartPrice",TotalPMPartPrice);
    return /*#__PURE__*/ React.createElement(Accordion, {
        sx: {
            border: "1px solid",
            borderColor: getBorderColor(props, switchEnabled),
            borderRadius: '8px'
        },
        expanded: props === null || props === void 0 ? void 0 : props.isAccordianOpen
    }, /*#__PURE__*/ React.createElement(AccordionSummary, {
        sx: {
            flexDirection: 'row-reverse'
        },
        expandIcon: props.switchButtonsEnabled || switchEnabled ? /*#__PURE__*/ React.createElement(ArrowForwardIosSharpIcon, {
            sx: {
                fontSize: '0.9rem'
            },
            onClick: onAccordianClick,
            id: props.KeyForId
        }) : null
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        alignItems: "center",
        sx: {
            marginLeft: '8px',
            cursor: 'default'
        },
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        onClick: onAccordianClick,
        sx: {
            cursor: 'pointer'
        },
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: props.id,
        variant: "caption",
        sx: _objectSpread({
            fontWeight: "strong",
            fontSize: 'base',
            color: "".concat(props.switchButtonsEnabled || switchEnabled ? 'text.primary' : 'text.disabled'),
            textTransform: 'capitalize'
        }, (props === null || props === void 0 ? void 0 : props.isMandatory) && {
            '&::after': {
                content: '"*"',
                color: 'red'
                // marginLeft: '2px',
            }
        })
    }, props.title), props.countVisible && /*#__PURE__*/ React.createElement(Chip, {
        label: props !== null && props !== void 0 && props.listLength ? props === null || props === void 0 ? void 0 : props.listLength : 0,
        id: "".concat(props.title, "-count"),
        color: "primary",
        variant: "filled",
        shape: "circular",
        sx: {
            marginLeft: {
                xs: '4px',
                md: '10px'
            }
        }
    }), props.declinejobCountVisible && /*#__PURE__*/ React.createElement(React.Fragment, null, props !== null && props !== void 0 && props.declineJobLength ? /*#__PURE__*/ React.createElement(Chip, {
        label: (props === null || props === void 0 ? void 0 : props.declineJobLength) || 0,
        id: "declineCount",
        color: "error",
        variant: "filled",
        shape: "circular",
        sx: {
            marginLeft: '5px'
        }
    }) : /*#__PURE__*/ React.createElement(Chip, {
        label: 0,
        id: "declineCountZero",
        color: "error",
        variant: "filled",
        shape: "circular",
        sx: {
            marginLeft: '5px'
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, null, (props === null || props === void 0 ? void 0 : props.KeyForId) === "TASK_DETAILS_".concat(EModuleSection.PeriodicMaintenance) && /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            paddingX: {
                xs: '0px',
                md: '10px'
            }
        },
        alignItems: "center"
    }, PmPartCalculateLoader ? /*#__PURE__*/ React.createElement("span", {
        style: {
            width: '50px',
            height: '20px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(Typography, {
        id: "PM-Parts-Amt",
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(TotalPMPartPrice === null || TotalPMPartPrice === void 0 ? void 0 : TotalPMPartPrice.toFixed(2)))), !props.hideSwitch && Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(IOSSwitch, {
        id: "toggle",
        onChange: onSwitchChange,
        checked: props.switchButtonsEnabled ? props.switchButtonsEnabled : switchEnabled,
        disabled: props !== null && props !== void 0 && props.isDisabled ? props === null || props === void 0 ? void 0 : props.isDisabled : false
    })))), /*#__PURE__*/ React.createElement(AccordionDetails, {
        sx: {
            paddingX: '12px',
            bgcolor: systemColor.backgroundColor,
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px'
        }
    }, props.children));
}
